export default __webpack_public_path__ + "static/media/game.75a045dc.png";